import z from'zod';var groupCategorySchema=z.object({id:z.string(),name:z.string(),count:z.number()});export{groupCategorySchema};